import React, { useState } from 'react';
import { Copy, Check } from 'lucide-react';
const DEFAULT_LINKS = [ ];
const ExampleLinks = ({ links = DEFAULT_LINKS, title = 'Examples:' }) => {
  const [copiedIndex, setCopiedIndex] = useState(null);
  const handleCopy = async (text, index) => {
    try {
      await navigator.clipboard.writeText(`https://api.axionquant.com${text}`)
      setCopiedIndex(index);
      window.setTimeout(() => {
        setCopiedIndex((current) => (current === index ? null : current));
      }, 1500);
    } catch (err) {
      console.error('Failed to copy text:', err);
    }
  };
  return (
    <div className="py-0 pb-10">
      {title && (
        <h3 className="text-lg font-medium text-gray-900 mb-3">{title}</h3>
      )}
      <div className="flex flex-col gap-2.5">
        {links.map((link, index) => {
          const text = typeof link === 'string' ? link : link.label;
          const isCopied = copiedIndex === index;
          return (
            <div
              key={text + index}
              className="flex items-center justify-between gap-1 w-full max-w-full min-w-0 rounded-lg bg-gray-100 pl-4 pr-1.5 py-1.5"
            >
              <code className="min-w-0 break-all font-mono text-sm text-emerald-600">
                https://api.axionquant.com{text}
              </code>
              <button
                type="button"
                onClick={() => handleCopy(text, index)}
                className="flex items-center justify-center cursor-pointer w-7 h-7 shrink-0 rounded-md text-gray-400 hover:text-gray-600 hover:bg-gray-200 active:scale-95 transition-all duration-150"
                aria-label={isCopied ? 'Copied' : 'Copy to clipboard'}
              >
                {isCopied ? (
                  <Check className="w-4 h-4 text-emerald-600" strokeWidth={2.5} />
                ) : (
                  <Copy className="w-4 h-4" strokeWidth={2} />
                )}
              </button>
            </div>
          );
        })}
      </div>
    </div>
  );
};
export default ExampleLinks;
